import React from 'react'
import InputPrice from '../../form-components/inputs/InputPrice'
import { onCellEditComplete } from './common'

const numberEditor = ({ options, propsInput }) => (
  <InputPrice
    value={options?.value}
    onChange={({ target: { value } }) => options.editorCallback(value ?? 0)}
    {...propsInput}
  />
)

const editPriceRowColumn = ({ propsInput }) => {
  return {
    editor: (options) => numberEditor({ options, propsInput }),
    onCellEditComplete,
  }
}

export default editPriceRowColumn
